import { Footer, Header, SEO } from "@/components";
import SEOConfig from "@/common/seo.config";
import { fetchBlogList } from "@/lib/blogs";
import { HOME_BLOG_LIMIT } from "@/components/main/aiBlog";
import { fetchServiceSolutions } from "@/lib/service-solutions";
import RelatedSolutionsComponent from "@/common/related-solutions";
import AiMvpPocDevelopmentComponent, {
  FAQS,
} from "@/components/services/mvp-poc-development";
import React from "react";
import { buildServicePageSchema } from "@/lib/service-page-schema";

const PATH = "/mvp-poc-development";

function MvpPocDevelopment({ posts = [], relatedSolutions = [] }) {
  return (
    <>
      <SEO
        {...SEOConfig.mvpPocDevelopment}
        structuredData={buildServicePageSchema({
          config: SEOConfig.mvpPocDevelopment,
          path: PATH,
          faqs: FAQS,
          serviceType: "AI MVP and PoC Development",
        })}
      />
      <Header />
      <main>
        <AiMvpPocDevelopmentComponent posts={posts} />
        <RelatedSolutionsComponent
          data={relatedSolutions}
          title="Solutions built on this capability"
          subtitle="Where we apply this work for specific teams and industries."
        />
      </main>
      <Footer />
    </>
  );
}

export async function getStaticProps() {
  const [posts, relatedSolutions] = await Promise.all([
    fetchBlogList({ limit: HOME_BLOG_LIMIT }),
    fetchServiceSolutions(PATH),
  ]);

  return {
    props: { posts, relatedSolutions },
    revalidate: 300,
  };
}

export default MvpPocDevelopment;
